module.exports = __webpack_public_path__ + "img/vertical_7_4_2.d0ce3753.png";